
import { defineComponent, onBeforeMount, reactive } from 'vue'
import moment from 'moment'

// components
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import List from '@/common/components/UI/List/index.vue'
import OneCListItem from '@/modules/OneCModule/components/OneCListItem/index.vue'
import FailedFetch from '@/common/components/UI/FailedFetch/index.vue'

// realisations
import { onec } from '@/core/realisations/onec.realisation'

// validations
import { OneCValidation } from '@/modules/OneCModule/validations/OneC.validation'
import useVuelidate from '@vuelidate/core'
import { DataState } from '@/core/classes/DataState.class'

// types
import { OneCT } from '@/core/types/one_c.types'

export default defineComponent({
    components: {
        'the-input': TheInput,
        'the-button': TheButton,
        'one-c-list-item': OneCListItem,
        'failed-fetch': FailedFetch,
        list: List,
    },
    setup() {
        const state = reactive({
            is_loading: false,
            from_date: null as string | null,
            to_date: null as string | null,
        })

        const data_state = reactive({
            one_c: new DataState<OneCT>({}),
        })

        const state_form$ = useVuelidate(OneCValidation, state)

        const restoreOrders = async () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            try {
                state.is_loading = true

                const moment_from = moment(state.from_date)
                const moment_to = moment(state.to_date)

                if (moment_to.diff(moment_from, 'days') < 1) {
                    alert('Дата до, должна быть позднее на 1 день')
                    return
                }

                const payload = {
                    fromDate: moment_from.format('YYYY-MM-DD'),
                    toDate: moment_to.format('YYYY-MM-DD'),
                }

                await onec.restoreOrders(payload)
            } catch (error) {
                console.error(error)
            } finally {
                state.is_loading = false
            }
        }

        const loadOneC = async (page: number) => {
            data_state.one_c.pagination.current_page = page
            const params = {
                page,
                createdAtFrom: state.from_date,
                createdAtTo: state.to_date,
                numberIsNull: 1,
            }

            try {
                data_state.one_c.is_loading = true
                const response = await onec.getList(params)

                data_state.one_c.list = response.data
                data_state.one_c.pagination.total_pages = response.meta.last_page

                data_state.one_c.is_failed = false
                data_state.one_c.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.one_c.failure.catchError(error)

                if (!data_state.one_c.failure.error_state.is_cancel) {
                    data_state.one_c.is_failed = true
                }
            } finally {
                if (!data_state.one_c.failure.error_state.is_cancel) {
                    data_state.one_c.is_loading = false
                }
            }
        }

        const reset = () => {
            state.from_date = null
            state.to_date = null

            loadOneC(1)
        }

        const setCurrentDate = () => {
            const today = new Date()
            const month =
                today.getMonth() + 1 < 10 ? '0' + (today.getMonth() + 1) : today.getMonth() + 1
            const day = today.getDate() < 10 ? '0' + today.getDate() : today.getDate()
            const next_day =
                today.getDate() + 1 < 10 ? '0' + (today.getDate() + 1) : today.getDate() + 1

            state.from_date = today.getFullYear() + '-' + month + '-' + day
            state.to_date = today.getFullYear() + '-' + month + '-' + next_day
        }

        onBeforeMount(async () => {
            setCurrentDate()
            await loadOneC(1)
        })

        return { state, data_state, state_form$, restoreOrders, loadOneC, reset }
    },
})
